import { Quote, Linkedin } from "lucide-react";
import { Card } from "./ui/card";

const testimonials = [
    {
        name: "Ellen Sun, CSM",
        role: "Senior Software Engineer",
        content:
            "I had the pleasure of working with Amelia and can confidently say she would be an excellent addition to any front-end development team. Beyond her technical strengths, Amelia is collaborative, reliable, and proactive. She communicates clearly, takes feedback well, and often goes the extra mile to improve both the product and the team’s workflow. Any team looking for a motivated, skilled front-end developer would be lucky to work with her, and I wholeheartedly recommend her.",
        avatar: "ES",
        linkedIn: true,
        url: "https://www.linkedin.com/in/msellensun/",
    },
    {
        name: "Sandra Campuzano",
        role: "Tech & Office Professional",
        content:
            "Amelia is an amazing, hard working team player who excels at any task provided to her. Her innovation and research has led to us creating SheHired, which stemmed from a one time project, into an ongoing one. She is a self starter, and always has a positive attitude no matter the situation. Amelia is always ready to learn, as well as teach others with the kindness and care that is missing from so many in the technology field. Anyone would be lucky to have Amelia on her team.",
        avatar: "SC",
        linkedIn: true,
        url: "https://www.linkedin.com/in/sandraicampuzano/",
    },
];

const Testimonials = () => {
    return (
        <section id="testimonials" className="py-24 px-6 bg-background">
            <div className="max-w-7xl mx-auto">
                <div className="text-center mb-16 animate-fade-up">
                    <p className="text-primary font-medium mb-2">LinkedIn Feedback</p>
                    <h2 className="text-3xl md:text-4xl font-bold text-foreground">
                        About Me
                    </h2>
                    <span className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-20 h-1 bg-crimson rounded-full"></span>
                </div>

                <div className="flex m-auto md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {testimonials.map((testimonial, index) => (
                        <Card
                            key={testimonial.name}
                            className="group p-6 bg-card border-border hover:border-primary/50 hover:shadow-card transition-all duration-300 animate-fade-up relative overflow-hidden"
                            style={{ animationDelay: `${index * 0.1}s` }}
                        >
                            {/* LinkedIn badge */}
                            {testimonial.linkedIn && (
                                <div className="absolute top-4 right-4">
                                    <a href={testimonial.url} target="_blank" rel="noopener noreferrer"><Linkedin className="h-5 w-5 text-primary/40" /></a>
                                </div>
                            )}

                            <Quote className="h-8 w-8 text-primary/30 mb-4" />
                            <p className="text-muted-foreground leading-relaxed mb-6">
                                "{testimonial.content}"
                            </p>
                            <div className="flex items-center gap-4">
                                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-primary/20 to-primary/40 flex items-center justify-center text-primary font-semibold border-2 border-primary/20">
                                    {testimonial.avatar}
                                </div>
                                <div>
                                    <p className="font-semibold text-foreground">
                                        {testimonial.name}
                                    </p>
                                    <p className="text-sm text-muted-foreground">
                                        {testimonial.role}
                                    </p>
                                </div>
                            </div>
                        </Card>
                    ))}
                </div>

                <div className="text-center mt-12">
                    <a
                        href="https://linkedin.com/in/ameliadutta"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 text-primary hover:underline font-medium"
                    >
                        <Linkedin className="h-4 w-4" />
                        View more on LinkedIn
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
